export const SAVE_CART_REQUEST = 'SAVE_CART_REQUEST';
export const saveCartRequest = (lineItems, isCommitting) => {
  return {
    type: SAVE_CART_REQUEST,
    lineItems,
    isCommitting,
  };
};

export const OPEN_CART_FOR_DESKTOP = 'OPEN_CART_FOR_DESKTOP';
export const openCartForDesktop = (shouldAutoClose = false) => ({
  type: 'OPEN_CART_FOR_DESKTOP',
  shouldAutoClose,
});

export const CHANGE_LINE_ITEM_QUANTITY = 'CHANGE_LINE_ITEM_QUANTITY';
export const changeLineItemQuantity = ({
  lineItem,
  quantity,
  currentOrder,
}) => ({
  type: CHANGE_LINE_ITEM_QUANTITY,
  lineItem,
  quantity,
  currentOrder,
});

export const CHANGE_LINE_ITEM_PROCESSING_QUANTITY =
  'CHANGE_LINE_ITEMS_PROCESSING_QUANTITY';
export const changeLineItemProcessingQuantity = ({
  lineItem,
  quantity,
  offeringId,
}) => {
  return {
    type: CHANGE_LINE_ITEM_PROCESSING_QUANTITY,
    lineItem,
    quantity,
    offeringId,
  };
};

export const SAVE_CART_SUCCESS = 'SAVE_CART_SUCCESS';
export const saveCartSuccess = (order, shouldResetPendingItems = true) => ({
  type: SAVE_CART_SUCCESS,
  order,
  shouldResetPendingItems,
});

export const SAVE_CART_ERROR = 'SAVE_CART_ERROR';
export const saveCartError = error => ({
  type: SAVE_CART_ERROR,
  error,
});

export const CHANGE_VARIANT_QUANTITY = 'CHANGE_VARIANT_QUANTITY';

export const changeVariantQuantity = (variant, offeringId, quantity) => {
  return {
    type: CHANGE_VARIANT_QUANTITY,
    variant,
    offeringId,
    quantity,
  };
};

export const CHANGE_QUICK_SHOP_SELECTED_VARIANT =
  'CHANGE_QUICK_SHOP_SELECTED_VARIANT';

export const changeQuickShopSelectedVariant = variant => ({
  type: CHANGE_QUICK_SHOP_SELECTED_VARIANT,
  variant,
});

export const CHANGE_QUICK_SHOP_MODAL_VISIBILITY =
  'CHANGE_QUICK_SHOP_MODAL_VISIBILITY';

export const changeQuickShopVisibility = (
  value,
  variants,
  showExciseTaxDisclaimer
) => ({
  type: CHANGE_QUICK_SHOP_MODAL_VISIBILITY,
  value,
  variants,
  showExciseTaxDisclaimer,
});

export const TOGGLE_CART_VISIBILITY = 'TOGGLE_CART_VISIBILITY';

export const toggleCartVisibility = shouldOpen => {
  return {
    shouldOpen,
    type: TOGGLE_CART_VISIBILITY,
  };
};

export const CHANGE_ORDER_MEMBERSHIP = 'CHANGE_ORDER_MEMBERSHIP';

export const changeOrderMembership = (value, eventLocation) => {
  return {
    type: CHANGE_ORDER_MEMBERSHIP,
    value,
    eventLocation,
  };
};

export const CHANGE_SUBSCRIBING_STATUS = 'CHANGE_SUBSCRIBING_STATUS';

export const changeSubscribingStatus = value => ({
  type: CHANGE_SUBSCRIBING_STATUS,
  value,
});

export const CHANGE_COMMITMENT_DETAILS_MODAL_VISIBILITY =
  'CHANGE_COMMITMENT_DETAILS_MODAL_VISIBILITY';

export const changeCommitmentDetailsModalVisibility = value => ({
  type: CHANGE_COMMITMENT_DETAILS_MODAL_VISIBILITY,
  value,
});

export const CHANGE_NICOTINE_STRENGTH_DETAILS_MODAL_VISIBILITY =
  'CHANGE_NICOTINE_STRENGTH_DETAILS_MODAL_VISIBILITY';

export const changeNicotineStrengthDetailsModalVisibility = value => ({
  type: CHANGE_NICOTINE_STRENGTH_DETAILS_MODAL_VISIBILITY,
  value,
});

export const SHOW_ADD_TO_CART_MESSAGE = 'SHOW_ADD_TO_CART_MESSAGE';

export const showAddToCartMessage = quantity => ({
  type: SHOW_ADD_TO_CART_MESSAGE,
  quantity,
});

export const HIDE_ADD_TO_CART_MESSAGE = 'HIDE_ADD_TO_CART_MESSAGE';

export const hideAddToCartMessage = () => ({
  type: HIDE_ADD_TO_CART_MESSAGE,
});

export const WIPE_CART = 'WIPE_CART';

export const wipeCart = () => ({
  type: WIPE_CART,
});

export const SIDEBAR_FOCUS_CHANGED = 'SIDEBAR_FOCUS_CHANGED';
export const sidebarFocusChanged = isFocused => ({
  type: SIDEBAR_FOCUS_CHANGED,
  isFocused,
});

export const CHANGE_COMMITMENT_UPSELL_MODAL_VISIBILITY =
  'CHANGE_COMMITMENT_UPSELL_MODAL_VISIBILITY';
export const changeCommitmentUpsellModalVisibility = value => ({
  type: CHANGE_COMMITMENT_UPSELL_MODAL_VISIBILITY,
  value,
});

export const REQUEST_COMMITMENT_UPSELL_MODAL_VISIBILITY =
  'REQUEST_COMMITMENT_UPSELL_MODAL_VISIBILITY';
export const requestCommitmentUpsellModalVisibility = () => ({
  type: REQUEST_COMMITMENT_UPSELL_MODAL_VISIBILITY,
});

export const REPORT_EVERGREEN_OFFERING = 'REPORT_EVERGREEN_OFFERING';
export const reportEvergreenOffering = offering => ({
  type: REPORT_EVERGREEN_OFFERING,
  offering,
});

export const CART_LINE_ITEMS_COUNT_REQUESTED =
  'CART_LINE_ITEMS_COUNT_REQUESTED';
export const cartLineItemsCountRequested = () => ({
  type: CART_LINE_ITEMS_COUNT_REQUESTED,
});

export const CART_LINE_ITEMS_COUNT_LOADED = 'CART_LINE_ITEMS_COUNT_LOADED';
export const cartLineItemsCountLoaded = response => ({
  type: CART_LINE_ITEMS_COUNT_LOADED,
  totalItems: response.count,
});

export const CART_LINE_ITEMS_COUNT_ERROR = 'CART_LINE_ITEMS_COUNT_ERROR';

export const CONVERT_ORDER_TO_SUBSCRIPTION = 'CONVERT_ORDER_TO_SUBSCRIPTION';
export const convertOrderToSubscription = order => ({
  type: CONVERT_ORDER_TO_SUBSCRIPTION,
  order,
});

export const CONVERT_ORDER_TO_SUBSCRIPTION_CLEAR =
  'CONVERT_ORDER_TO_SUBSCRIPTION_CLEAR';
export const convertOrderToSubscriptionClear = () => ({
  type: CONVERT_ORDER_TO_SUBSCRIPTION_CLEAR,
});
